if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        // Ingredient popups are rendered inside the accordion item, whose .blocks-radius
        // mask-image clips even position:fixed descendants to the card. Hoist them to <body>
        // so the overlay and popup cover the whole screen (lookup is by id, so it still works).
        this.querySelectorAll('.product-step-popup').forEach((popup) => {
          const stale = document.body.querySelector(':scope > #' + CSS.escape(popup.id));
          if (stale && stale !== popup) stale.remove();
          document.body.appendChild(popup);
        });

        // Tab videos render without native controls, so a tap on the playing video pauses it
        // (the theme's play button reappears while paused and handles resume).
        this.addEventListener('click', (event) => {
          const video = event.target.closest('.accordion-video-wrap--clean video');
          if (!video || video.paused) return;
          event.preventDefault();
          video.closest('video-element').paused = true;
          video.pause();
        });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        details.querySelectorAll('video').forEach((video) => video.pause());
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
